import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import Loader from '../../components/loader';

import {
  fetchAddress,
} from '../../actions';

class ViewAutomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      isDeleting: false,
      newPriority: '',
      pristine: true,
      addressLoaded: false,
      automationAddresses: [],
    };
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.toggleEditing = this.toggleEditing.bind(this);
    this.toggleDeleting = this.toggleDeleting.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAddresses = this.handleAddresses.bind(this)
  }

  componentDidMount() {
    const { dispatch, automationDetails } = this.props;

    const useAsset = automationDetails.meta.depositAsset;

    const usePriority = automationDetails.priority.toString() || '';

    this.setState({newPriority: usePriority  });

    const data = {
      asset: useAsset,
    };

    dispatch(fetchAddress(data))
      .then((res) => {
        if (res.type === 'FETCH_ADDRESS_SUCCESS') {
          this.handleAddresses();
        }
      });
  }

  componentDidUpdate() {
  }

  handleAddresses() {
    const { dispatch, coins } = this.props;
    const { walletAddresses } = this.state;

    let useAddresses;

    if (coins && coins.length) {
      useAddresses = coins.filter((item) => {
        return item.autoBuy === true;
      });
    }

    this.setState({ automationAddresses: useAddresses, addressLoaded: true });
  }

  copyToClipboard(e) {
    this.depositaddress.select();
    document.execCommand('copy');
    e.target.focus();
  }

  toggleEditing() {
    const { isEditing } = this.state;
    const { automationDetails } = this.props;

    const usePriority = automationDetails.priority.toString() || '';

    this.setState({isEditing: !isEditing, newPriority: usePriority, pristine: true});
  }

  toggleDeleting() {
    const { isDeleting } = this.state;
    this.setState({isDeleting: !isDeleting, pristine: true});
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  render() {
    const { user, errors, success, assets } = this.props;
    const {
      automationDetails,
      handleUpdateAutomation,
      handleDeleteAutomation,
      handleChange,
    } = this.props;

    const { isEditing, isDeleting, newPriority, pristine, addressLoaded, automationAddresses } = this.state;

    const buyLoop = automationDetails.meta && automationDetails.meta.assetsToBuy && automationDetails.meta.assetsToBuy.length && automationDetails.meta.assetsToBuy.map((buy, index) => {
      const key = `buy-${index}`;

      let assetName;

      if (assets && assets.length && buy.asset) {
        assetName = assets.find(e => e.handle === buy.asset);
      }

      if (assetName && assetName.name) {
        assetName = assetName.name;
      }

      return (
        <div key={key} className="flex-container align-middle" style={{marginBottom: 8}}>
          <div style={{
            marginRight: 32,
            color: '#2c40c3',
            fontWeight: 'bold'
          }}>
            {buy.percentage}%
          </div>
          <div className={`vlt-coin ${assetName.replace(/\s/g, "-").toLowerCase()}`}>
            <img alt={assetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${assetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
          </div>
          <div style={{marginLeft: 8}}>
            {buy.asset}
          </div>
        </div>
      );
    });

    let useAddress = '';

    if (automationAddresses && (automationAddresses.length || automationAddresses.address)) {
      useAddress = automationAddresses.address || automationAddresses[0].address;
    }

    const automationReference = automationDetails.referenceId || '';

    const editIsReady = newPriority && newPriority.length && (Number(newPriority) > 0) && !pristine;

    let assetName;

    if (assets && assets.length && automationDetails.meta.depositAsset) {
      assetName = assets.find(e => e.handle === automationDetails.meta.depositAsset);
    }

    if (assetName && assetName.name) {
      assetName = assetName.name;
    }

    if (!addressLoaded) {
      return (
        <div className="cell small-12 medium-12 large-12 automation-modal">
          <div className="modal-heading">
            Automated Trade Details
          </div>
          <div className="grid-x modal-body">
            <div className="center-loader" style={{ minHeight: 200, width: '100%' }}>
              <Loader logo dark />
            </div>
          </div>
        </div>
      );
    }

    // if (isEditing) {
    //   return (
    //     <div className="cell small-12 medium-12 large-12 automation-modal">
    //       <div className="modal-heading">
    //         Automated Trade Details
    //       </div>
    //       <div className="modal-subheading">
    //         Changing the priority will affect the order that your automations are completed. Chainging this to a position that is already occupied by another automation will swap both of their positions.
    //       </div>
    //       <div className="grid-x modal-body">
    //         <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
    //           <div className="input-wrapper">
    //             <p className="iw-l"><b>Priority:</b></p>
    //             <input id="newPriority" className="modal-input" type="number" name="Priority" placeholder="Priority" value={newPriority || ''} onChange={this.handleChange} />
    //           </div>
    //           <hr />
    //         </div>
    //         <div className="cell small-12 medium-12 large-12">
    //           <div className="lr-p">
    //             <span className="mute">
    //               Wallet Address:
    //             </span>
    //             <span>
    //               {useAddress || ''}
    //             </span>
    //           </div>
    //           <div className="lr-p">
    //             <span className="mute">
    //               Deposit Asset:
    //             </span>
    //             <span>
    //               {automationDetails.meta.depositAsset || ''}
    //             </span>
    //           </div>
    //           <div className="lr-p">
    //             <span className="mute">
    //               Buy Assets:
    //             </span>
    //             <span>
    //               {buyLoop}
    //             </span>
    //           </div>
    //         </div>
    //
    //       </div>
    //       { isDeleting ? (
    //         <>
    //           <div className="cell small-12 medium-12 large-12 modal-actions">
    //             <button
    //               className="button"
    //               type="button"
    //               onClick={() => this.toggleDeleting()}>
    //               <span>
    //                 Cancel
    //               </span>
    //             </button>
    //             <button
    //               className="vlt-button vlt-red"
    //               type="button"
    //               onClick={() => handleDeleteAutomation(automationReference)}>
    //               <span>
    //                 Confirm Delete
    //               </span>
    //             </button>
    //           </div>
    //         </>
    //       ) : (
    //         <>
    //           <div className="cell small-12 medium-12 large-12 modal-actions">
    //             <button
    //               className="button"
    //               type="button"
    //               onClick={() => this.toggleEditing()}>
    //               <span>
    //                 Cancel
    //               </span>
    //             </button>
    //             <button
    //               className="vlt-button"
    //               type="button"
    //               onClick={() => handleUpdateAutomation(newPriority, automationReference)}
    //               disabled={!editIsReady}
    //             >
    //               <span>
    //                 Save
    //               </span>
    //             </button>
    //           </div>
    //           <div className="cell small-12 medium-12 large-12 modal-actions">
    //             <p
    //               className="p-warn"
    //             >
    //               <span
    //                 onClick={() => this.toggleDeleting()}
    //                 style={{cursor: 'pointer', marginBottom: 0}}
    //               >
    //                 Delete this automation
    //               </span>
    //             </p>
    //           </div>
    //         </>
    //       )}
    //     </div>
    //   );
    // }

    if (isDeleting) {
      return (
        <div className="cell small-12 medium-12 large-12 automation-modal">
          <div className="modal-heading">
            Automated Trade Details
          </div>
          <div className="modal-subheading">
            Depositing {automationDetails.meta.depositAsset || ''} to the address below will automatically trigger the trades you have configured.
          </div>
          <div className="grid-x modal-body">
            <div className="cell small-12 medium-12 large-12">
              <p style={{textAlign: 'center'}}><b>Deposit Address:</b></p>
              <div className="input-copy-wrap">
                <div className="input-wrapper">
                  <input
                    className="modal-input"
                    type="text"
                    name="depositaddress"
                    placeholder="Deposit Address"
                    value={useAddress}
                    readOnly
                    ref={(depositaddress) => this.depositaddress = depositaddress}
                  />
                </div>
                <button type="button" disabled={!useAddress} className="vlt-button" onClick={this.copyToClipboard}>
                  <span>
                    <FontAwesomeIcon
                      style={
                        useAddress ? { color: '#9b4c25' } : { color: '#5e5e5e' }
                      }
                      size="lg"
                      icon={faCopy}
                    />
                  </span>
                </button>
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <hr />
              <div className="lr-p lr-p--top">
                <div style={{marginTop: 5}}>
                  <b>When I deposit:</b>
                </div>
                <div className="flex-container align-middle">
                  <div className={`vlt-coin ${assetName.replace(/\s/g, "-").toLowerCase()}`}>
                    <img alt={assetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${assetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
                  </div>
                  <div style={{marginLeft: 8}}>
                    {automationDetails.meta.depositAsset || ''}
                  </div>
                </div>
              </div>
              <hr />
              <div className="lr-p lr-p--top">
                <div style={{marginTop: 5}}>
                  <b>I want to buy:</b>
                </div>
                <div>
                  {buyLoop}
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <p style={{marginTop: 0}}>
              <b>Are you sure you want to delete this automation?</b>
            </p>
          </div>
          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button
              className="button"
              type="button"
              onClick={() => this.toggleDeleting()}>
              <span>
                Cancel
              </span>
            </button>
            <button
              className="vlt-button vlt-red"
              type="button"
              onClick={() => handleDeleteAutomation(automationReference)}>
              <span>
                Confirm Delete
              </span>
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="cell small-12 medium-12 large-12 automation-modal">
        <div className="modal-heading">
          Automated Trade Details
        </div>
        <div className="modal-subheading">
          Depositing {automationDetails.meta.depositAsset || ''} to the address below will automatically trigger the trades you have configured.
        </div>
        <div className="grid-x modal-body">
          <div className="cell small-12 medium-12 large-12">
            <p style={{textAlign: 'center'}}><b>Deposit Address:</b></p>
            <div className="input-copy-wrap">
              <div className="input-wrapper">
                <input
                  className="modal-input"
                  type="text"
                  name="depositaddress"
                  placeholder="Deposit Address"
                  value={useAddress}
                  readOnly
                  ref={(depositaddress) => this.depositaddress = depositaddress}
                />
              </div>
              <button type="button" disabled={!useAddress} className="vlt-button" onClick={this.copyToClipboard}>
                <span>
                  <FontAwesomeIcon
                    style={
                      useAddress ? { color: '#9b4c25' } : { color: '#5e5e5e' }
                    }
                    size="lg"
                    icon={faCopy}
                  />
                </span>
              </button>
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            {/* <div className="lr-p">
              <span className="mute">
                Priority:
              </span>
              <span>
                {automationDetails.priority || ''}
              </span>
            </div> */}
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 5}}>
                <b>When I deposit:</b>
              </div>
              <div className="flex-container align-middle">
                <div className={`vlt-coin ${assetName.replace(/\s/g, "-").toLowerCase()}`}>
                  <img alt={assetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${assetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
                </div>
                <div style={{marginLeft: 8}}>
                  {automationDetails.meta.depositAsset || ''}
                </div>
              </div>
            </div>
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 5}}>
                <b>I want to buy:</b>
              </div>
              <div>
                {buyLoop}
              </div>
            </div>
            <hr />
          </div>

        </div>
        <div className="cell small-12 medium-12 large-12 modal-actions">
          <button
            className="button"
            type="button"
            onClick={() => this.props.toggleModal(null)}>
            <span>
              Close
            </span>
          </button>
          {/* <button
            className="vlt-button"
            type="button"
            onClick={() => this.toggleEditing()}>
            <span>
              Edit
            </span>
          </button> */}
          <button
            className="button"
            type="button"
            onClick={() => this.toggleDeleting()}
          >
            <span className="p-warn">
              Delete
            </span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
  coins: state.coins.coins,
});

export default withRouter(connect(mapStateToProps)(ViewAutomation));
